import { useState, useEffect } from "react";
import { getAllUsers } from "../services/usersService";
import CognitoUser from "../types/CognitoUser";

const PAGE_SIZE = 20;

export function useUsers() {
  const [users, setUsers] = useState<CognitoUser[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [loadingMore, setLoadingMore] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  const fetchUsers = async (progressive = true) => {
    setLoading(true);
    setError(null);
    try {
      if (progressive) {
        const data = await getAllUsers({ limit: PAGE_SIZE });
        const items = data?.users ?? [];
        const nextToken =
          (data as any)?.nextPaginationToken ?? null;
        setUsers(items);
        setLoading(false);
        if (nextToken) {
          setLoadingMore(true);
          let all = [...items];
          let token: string | null = nextToken;
          while (token) {
            const nextData = await getAllUsers({
              limit: PAGE_SIZE,
              paginationToken: token,
            });
            const nextItems = (nextData as any)?.users ?? [];
            const nextKey = (nextData as any)?.nextPaginationToken ?? null;
            all = [...all, ...nextItems];
            token = nextKey;
            setUsers(all);
          }
          setLoadingMore(false);
        } else if (items.length === 0) {
          const fullData = await getAllUsers();
          setUsers((fullData as any)?.users ?? []);
        }
      } else {
        const data = await getAllUsers();
        setUsers((data as any)?.users ?? []);
      }
    } catch (err) {
      console.error(err);
      setError("Failed to fetch users");
    } finally {
      setLoading(false);
      setLoadingMore(false);
    }
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  return { users, loading, loadingMore, error, fetchUsers };
}
